import { render, staticRenderFns } from "./KVLPICOJ.vue?vue&type=template&id=57136b61&scoped=true&"
import script from "./KVLPICOJ.vue?vue&type=script&lang=js&"
export * from "./KVLPICOJ.vue?vue&type=script&lang=js&"
import style0 from "./KVLPICOJ.vue?vue&type=style&index=0&id=57136b61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57136b61",
  null
  
)

export default component.exports